module.exports = __webpack_public_path__ + "resources/img/img_iTracerAF1_m.5f0140310fe6b9bc6b91c64611a21f12.png";